import { render } from "./2022-11-12-Vue MVVM MVC.md?vue&type=template&id=19d1431b"
const script = {}
script.render = render

export default script